import React from 'react';
import { CarIcon } from '../icons';


const SurveyComplete = () => {
    return (
        <div className="survey-complete" role="status">
            <div className="survey-complete-scene">
                <div className="survey-complete-road"/>
                <div className="survey-complete-car">
                    <CarIcon/>
                </div>
            </div>
            <div className="survey-complete-title">Survey complete!</div>
            <div className="survey-complete-sub">Your reward is on the way</div>
        </div>
    );
};

export default SurveyComplete;